import L from 'leaflet';

export function pointsDistance(p1, p2) {
  const pos = L.latLng(p1);
  return pos.distanceTo(p2);
}

export default function getDistance(points) {
  if (points.length < 2) {
    return 0;
  }
  return points
    .slice(1)
    .reduce(
      (sum, point, index) => sum + pointsDistance(point, points[index]),
      0,
    );
}
